import { createIconComponent } from '../../factory/create-icon-component';
export const RetailTagIcon = createIconComponent(
  'RetailTagIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="10"
      cy="10.0001"
      r="2"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 10.3491C3 11.3275 3 11.8166 3.11052 12.277C3.20851 12.6851 3.37012 13.0753 3.58944 13.4332C3.83681 13.8369 4.18271 14.1828 4.87451 14.8746L8.47452 18.4746C10.0586 20.0586 10.8506 20.8507 11.7639 21.1474C12.5673 21.4085 13.4327 21.4085 14.2361 21.1474C15.1494 20.8507 15.9414 20.0586 17.5255 18.4746L18.4745 17.5255C20.0586 15.9415 20.8506 15.1494 21.1474 14.2361C21.4084 13.4328 21.4084 12.5674 21.1474 11.764C20.8506 10.8507 20.0586 10.0586 18.4745 8.47458L14.8745 4.87458C14.1827 4.18277 13.8368 3.83687 13.4331 3.5895C13.0753 3.37019 12.6851 3.20857 12.2769 3.11058C11.8166 3.00006 11.3274 3.00006 10.349 3.00006H9.4C7.15979 3.00006 6.03968 3.00006 5.18404 3.43603C4.43139 3.81953 3.81947 4.43145 3.43597 5.1841C3 6.03975 3 7.15985 3 9.40006V10.3491Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
